import { C, STROKE, Figure, Label, Leader, arrow } from './figureStyle';

const ID = 'fig-ventilstift';

export default function VentilstiftFigure() {
  return (
    <Figure
      id={ID}
      height={240}
      title="Radiatorventil med termostathovedet taget af. En flad genstand trykker ventilstiften ind, og en dobbeltpil viser, at stiften går ind og fjedrer ud igen."
      caption="Med termostathovedet taget af trykkes ventilstiften ind med en flad genstand og fjedrer selv ud igen."
    >
      {/* Rør gennem ventilen mod radiatoren */}
      <line x1="4" y1="192" x2="112" y2="192" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <line x1="200" y1="192" x2="352" y2="192" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />

      {/* Ventilhus, pakdåse og stift */}
      <rect x="120" y="162" width="80" height="60" rx="8" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="146" y="140" width="28" height="22" rx="3" fill={C.line} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="157" y="120" width="6" height="20" rx="2" fill={C.dark} />

      {/* Flad genstand, der trykker på stiften */}
      <rect x="118" y="106" width="118" height="12" rx="6" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Ind og ud */}
      <line
        x1="104"
        y1="98"
        x2="104"
        y2="134"
        stroke={C.dark}
        strokeWidth={STROKE.secondary}
        markerStart={arrow(ID, 'dark')}
        markerEnd={arrow(ID, 'dark')}
      />

      {/* Termostathovedet, taget af */}
      <rect x="262" y="36" width="78" height="40" rx="10" fill="none" stroke={C.grey} strokeWidth={STROKE.secondary} strokeDasharray="4 4" />
      <rect x="286" y="76" width="30" height="8" rx="2" fill="none" stroke={C.grey} strokeWidth={STROKE.secondary} strokeDasharray="4 4" />

      {/* Labels */}
      <Label x={161} y={60} anchor="middle" lines={['Flad genstand']} />
      <Leader points="161,66 161,104" />
      <Label x={96} y={120} anchor="end" kind="note" lines={['Ind og ud']} />
      <Label x={232} y={134} lines={['Ventilstift']} />
      <Leader points="228,130 166,130" />
      <Label x={160} y={200} anchor="middle" lines={['Ventilhus']} />
      <Label x={301} y={100} anchor="middle" lines={['Termostathoved']} />
      <Label x={301} y={116} anchor="middle" kind="note" lines={['taget af']} />
    </Figure>
  );
}
